// =============================================================================
// DarkPreviewBanner - visible while the dark mode preview is on.
//
// Dark mode is not finished: roughly 437 colour literals across the staff app
// are still hardcoded, so some panels will show light patches. Anyone in the
// preview should know that what they are seeing is unfinished rather than
// broken, and should have somewhere obvious to note what they found.
// =============================================================================
import { createPortal } from "react-dom";
import { useEffect, useState } from "react";
import { C } from "../lib/tokens";
import { setPreviewOptIn } from "../lib/theme";

export default function DarkPreviewBanner({ active }) {
  const [hidden, setHidden] = useState(false);
  // On a phone the copy wraps to several lines. With a pill radius that turned
  // the banner into a large circle sitting on top of the dashboard - the radius
  // was sized for a single-line bar and nothing constrained it when the content
  // grew. Narrow viewports get a full-width bar with a normal radius instead.
  const [narrow, setNarrow] = useState(() => (typeof window !== "undefined" ? window.innerWidth <= 640 : false));
  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia("(max-width: 640px)");
    const h = (e) => setNarrow(e.matches);
    mq.addEventListener("change", h);
    return () => mq.removeEventListener("change", h);
  }, []);
  if (!active || hidden) return null;
  const node = (
    <div style={narrow ? {
      position: "fixed", left: 8, right: 8, bottom: 8, zIndex: 3900,
      display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10,
      padding: "10px 12px", borderRadius: 12,
      background: C.warnBg, color: C.warnFg, border: "1px solid " + C.warnBgStrong,
      fontSize: 12, lineHeight: 1.35, boxShadow: "0 8px 24px rgba(0,0,0,0.45)",
    } : {
      position: "fixed", left: "50%", transform: "translateX(-50%)", bottom: 14, zIndex: 3900,
      display: "flex", alignItems: "center", gap: 12,
      padding: "8px 14px", borderRadius: 999,
      background: C.warnBg, color: C.warnFg, border: "1px solid " + C.warnBgStrong,
      fontSize: 12, whiteSpace: "nowrap", boxShadow: "0 8px 24px rgba(0,0,0,0.35)", maxWidth: "92vw",
    }}>
      <span style={{ minWidth: 0 }}>
        <b>Dark mode preview.</b>{narrow ? "" : " Some panels still show light patches - that is known, not broken."}
      </span>
      <button
        onClick={() => { setPreviewOptIn(false); window.location.reload(); }}
        style={{ background: "transparent", border: "1px solid " + C.warnBgStrong, color: "inherit",
                 borderRadius: 8, padding: "3px 9px", fontSize: 11, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}
      >Back to light</button>
      <button onClick={() => setHidden(true)}
        style={{ background: "transparent", border: "none", color: "inherit", opacity: 0.7,
                 fontSize: 11, cursor: "pointer", fontFamily: "inherit" }}
      >Hide</button>
    </div>
  );
  return typeof document !== "undefined" ? createPortal(node, document.body) : node;
}
